export enum DigestFilterOperator {
    Equal = "equal",
    Substring = "substring",
    Prefix = "prefix",
    ContainsInList = "containsinlist",
}

export interface DigestFilterColumn {
    operator:
        | DigestFilterOperator.Equal
        | DigestFilterOperator.Substring
        | DigestFilterOperator.Prefix
        | DigestFilterOperator.ContainsInList;
    column: string;
    value: string;
}

interface PicklistRequestOrder {
    column: string;
    direction: "asc" | "desc";
}

export interface DigestQueryFilter {
    filter?: DigestFilter;
    skip?: number;
    take?: number;
    isTree?: boolean;

    order?: PicklistRequestOrder;
    autocomplete?: string;
    fields?: string;
}

export enum DigestLogicalOperator {
    And = "and",
    Or = "or",
}

export type DigestFilter = DigestLogicalFilter | DigestFilterColumn;

export interface DigestLogicalFilter {
    operator: DigestLogicalOperator;
    operands: DigestFilter[];
}
